export type AdChannel = 'facebook' | 'google' | 'tiktok';

const ALL_CHANNELS: AdChannel[] = ['facebook', 'google', 'tiktok'];

export function isAdSitePermissionCode(code: string): boolean {
  if (!code.startsWith('ad:')) return false;
  if (code.startsWith('ad:role:')) return false;
  if (code.startsWith('ad:channel:')) return false;
  return code.split(':').length === 3;
}

export function hasAnyAdSitePermissionCode(codes: string[]): boolean {
  return codes.some(isAdSitePermissionCode);
}

export function getAllowedSiteSlugsForBrand(codes: string[], brandName?: string): string[] {
  const normalizedBrand = String(brandName || '').trim().toLowerCase();
  if (!normalizedBrand) return [];
  return codes
    .filter((code) => isAdSitePermissionCode(code) && code.toLowerCase().startsWith(`ad:${normalizedBrand}:`))
    .map((code) => code.split(':')[2])
    .filter(Boolean);
}

export function normalizeChannelAccess(channels?: string[] | null): AdChannel[] {
  if (!channels || channels.length === 0) return [];
  const allowed = new Set(
    channels
      .map((channel) => String(channel).trim().toLowerCase())
      .filter((channel): channel is AdChannel => ALL_CHANNELS.includes(channel as AdChannel)),
  );
  return ALL_CHANNELS.filter((channel) => allowed.has(channel));
}

export function hasChannelAccess(channels: string[] | null | undefined, channel: AdChannel): boolean {
  return normalizeChannelAccess(channels).includes(channel);
}

export function getFirstAllowedChannel(channels?: string[] | null): AdChannel {
  return normalizeChannelAccess(channels)[0] ?? 'facebook';
}
